import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import '@gatecheckpro/design-system/tokens.css';
import '@gatecheckpro/design-system/base.css';
import { App } from './App.tsx';
import { SessionProvider } from './lib/session.tsx';

const container = document.getElementById('root');
if (container === null) throw new Error('Root container is missing');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
